import { useRef } from 'react'
import isMobile from 'ismobilejs'

import { useCustomerProductTourStatus } from 'hooks/useCustomerProductTourStatus'
import { useLoggedInUser } from 'hooks/useLoggedInUser'

export const useTapToPayModal = () => {
  const { userData } = useLoggedInUser()
  const { updateProductTourStatus } = useCustomerProductTourStatus()
  const hasNotSeenBefore = useRef(
    userData?.productTourStatus?.showTapToPayInstructions
  )
  const notTablet = !isMobile(window.navigator).tablet

  const shouldTapToPayModal = Boolean(hasNotSeenBefore.current && notTablet)

  return { shouldTapToPayModal, updateProductTourStatus }
}
